import { Component, OnInit, HostListener } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { UnityComponent } from '../unity/unity.component';
import { Subscription } from 'rxjs';
import {TimerObservable} from "rxjs/observable/TimerObservable";


@Component({
  selector: 'app-pause-overlay',
  templateUrl: './pause-overlay.component.html',
  styleUrls: ['./pause-overlay.component.css']
})
export class PauseOverlayComponent implements OnInit {

  timer = 0;
  show = false;
  constructor() { }
  unity: UnityComponent;
  flow = null;
  private subscription: Subscription;
  ngOnInit() {
  }
  @HostListener('document:mousemove', ['$event']) 
  onMouseMove(e) {
    this.timer = 0;
  }
  @HostListener('document:click', ['$event']) 
  onMouseClick(e) {
    this.EndIdle();
  }
  Show(state: boolean) {
    this.show = state;
  }
  WaitingForReady(u){
    this.unity = u;
    let timer = TimerObservable.create(0, 500);
    this.subscription = timer.subscribe(t => {
        if(this.unity.isLoading == false){
          this.Show(true);
          this.subscription.unsubscribe();
        };
    });
  }
  StartIdle(settings, flow){
    this.flow = flow;
    Observable.interval(1000)
      .map((x) => x+1)
      .subscribe((x) => {
        if(!this.show) this.timer ++;
        if(this.timer>settings.time){
          this.timer = 0;
          this.Show(true);
        };
    });
  }
  EndIdle(){
    this.timer = 0;
    if(this.show){
      this.Show(false);
      this.flow.onFlow();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pause-overlay/pause-overlay.component.ts